import CockpitNotificationDifferenceResourceModel from '../../generated/types/model/resource/CockpitNotificationDifferenceResourceModel';

export default class CockpitNotificationDifferenceResourceViewModel extends CockpitNotificationDifferenceResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
